import { useState, useEffect } from 'react';
import { TextField, Box } from '@mui/material';

interface TextFieldComponentProps {
  onChange: (event: any) => void;
  onBlur?: (event: any) => void;
  label: string;
  keyName: string;
  name: string;
  isRequired: boolean;
  value: string;
  placeholder?: string;
  errorStr: string;
  disabled?: boolean;
  style?: any;
  type?: string;
  boxStyle?: any;
  format?: any;
  inputRef?: any;
  suffix?: any;
  prefix?: any;
}
const TextFieldComponent: React.FC<TextFieldComponentProps> = ({
  onChange,
  onBlur,
  boxStyle,
  label,
  isRequired,
  value,
  keyName,
  name,
  placeholder,
  errorStr,
  disabled,
  style,
  type,
  format,
  inputRef,
  suffix,
  prefix,
}) => {
  // Local state for time inputs to prevent parent re-render from closing picker
  const [localTimeValue, setLocalTimeValue] = useState(value);

  // Sync local state when parent value changes
  useEffect(() => {
    if (type === 'time') {
      setLocalTimeValue(value);
    }
  }, [value, type]);

  // For time inputs, update locally and only notify parent on blur
  const handleTimeChange = (event: any) => {
    setLocalTimeValue(event.target.value);
  };

  const handleTimeBlur = (event: any) => {
    onChange({ target: { value: localTimeValue } });
    if (onBlur) {
      onBlur(event);
    }
  };

  return (
    <Box
      className="mb-3"
      sx={{ mb: 3 }}
      key={'ele_' + keyName}
      style={boxStyle}
    >
      {label && (
        <Box sx={{ mb: 1 }} className="form-label" key={'lbk_' + keyName}>
          {label}
          {isRequired && (
            <small style={{ color: 'red' }} key={'sml_' + keyName}>
              {' '}
              *
            </small>
          )}
        </Box>
      )}
      <TextField
        inputRef={inputRef}
        type={type ? type : 'text'}
        className="form-control form-control-loum"
        id={keyName}
        key={keyName}
        name={name}
        label=""
        onWheel={(e: any) => {
          e.target.blur();
        }}
        variant="outlined"
        placeholder={placeholder}
        value={type === 'time' ? localTimeValue : value}
        onChange={type === 'time' ? handleTimeChange : onChange}
        onBlur={type === 'time' ? handleTimeBlur : onBlur}
        style={style}
        fullWidth
        disabled={disabled}
        slotProps={{
          input: {
            startAdornment: prefix,
            endAdornment: suffix,
          },
        }}
      />
      {errorStr && <span className="bad-field">{errorStr}</span>}
    </Box>
  );
};
export default TextFieldComponent;
